/**
 * "Your location", "Near me", "Current location", a raw "49.49, -119.59" — what the browser or a
 * geolocation fallback calls wherever you are. None of them is a place, and none may ever be
 * printed as a town's name (a square named "Your location" once reached production).
 */
export function isPlaceholderPlace(label) {
  if (!label || !String(label).trim()) return true;
  const l = String(label).trim().toLowerCase();
  if (/location|near me|nearby|current/.test(l)) return true;
  return /^-?\d+\.\d+\s*,\s*-?\d+\.\d+$/.test(l);
}

/** The first label that names an actual place, or ''. */
export function realPlace(...labels) {
  return labels.find((l) => !isPlaceholderPlace(l)) || '';
}
